// extracted by mini-css-extract-plugin
module.exports = {"cube":"bp_hx","cube__content":"bp_hy","cube_color_white":"bp_hz"};